import { createClient } from '@supabase/supabase-js';
import { auth } from './firebase';

// Esta lógica verifica se estamos em um ambiente Vite (que tem import.meta.env)
// ou em um ambiente Node.js (que tem process.env).
const configuredSupabaseUrl = import.meta.env?.VITE_SUPABASE_URL ?? process.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env?.VITE_SUPABASE_ANON_KEY ?? process.env.VITE_SUPABASE_ANON_KEY;

// Ensaio local A10: mantém a origem/autenticação da aplicação e permite apontar
// somente a camada Supabase para uma cópia local restaurada. Nunca aceita esse
// override fora do modo DEV nem para hosts/portas diferentes do stack isolado.
const recoverySupabaseUrl = import.meta.env?.DEV && typeof window !== 'undefined'
  ? new URLSearchParams(window.location.search).get('a10RecoverySupabaseUrl')
  : null;
const supabaseUrl = recoverySupabaseUrl === 'http://127.0.0.1:55321'
  ? recoverySupabaseUrl
  : configuredSupabaseUrl;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error("Supabase URL ou Anon Key não encontradas. Verifique seu arquivo .env");
}

const getFirebaseAccessToken = async (): Promise<string | null> => {
  // O cliente Supabase pode emitir a primeira requisição enquanto o Firebase
  // ainda restaura a sessão persistida. Aguarde essa hidratação para não enviar
  // chamadas autenticadas como `anon` por uma condição de corrida.
  await auth.authStateReady();

  if (!auth.currentUser) {
    return null;
  }

  try {
    return await auth.currentUser.getIdToken();
  } catch (error) {
    console.warn("[supabase] Failed to read Firebase access token:", error);
    return null;
  }
};

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  accessToken: getFirebaseAccessToken,
});
